<div class="lottie-container">
  <ng-lottie [options]="options"></ng-lottie>
</div>
